import api from './client';

// ---------------------------------------------------------------------------
// Feature Flags
// ---------------------------------------------------------------------------

export interface FeatureFlag {
  name: string;
  description: string | null;
  default_enabled: boolean;
  tier_overrides: Record<string, boolean>;
}

export interface FeatureFlagCreate {
  name: string;
  description?: string | null;
  default_enabled?: boolean;
  tier_overrides?: Record<string, boolean>;
}

export interface FeatureFlagUpdate {
  description?: string | null;
  default_enabled?: boolean | null;
  tier_overrides?: Record<string, boolean> | null;
}

export async function listFeatureFlags() {
  const res = await api.get<FeatureFlag[]>('/super-admin/feature-flags');
  return res.data;
}

export async function createFeatureFlag(data: FeatureFlagCreate) {
  const res = await api.post<FeatureFlag>('/super-admin/feature-flags', data);
  return res.data;
}

export async function updateFeatureFlag(name: string, data: FeatureFlagUpdate) {
  const res = await api.put<FeatureFlag>(`/super-admin/feature-flags/${encodeURIComponent(name)}`, data);
  return res.data;
}

export async function deleteFeatureFlag(name: string) {
  await api.delete(`/super-admin/feature-flags/${encodeURIComponent(name)}`);
}

// ---------------------------------------------------------------------------
// Tenants
// ---------------------------------------------------------------------------

export interface TenantInfo {
  id: string;
  slug: string;
  name: string;
  tier: string;
  status: string;
  max_users: number;
  contact_email: string;
  created_at: string;
}

export interface TenantUpdate {
  tier?: string | null;
  status?: string | null;
  max_users?: number | null;
}

export async function listTenants() {
  const res = await api.get<TenantInfo[]>('/super-admin/tenants');
  return res.data;
}

export async function updateTenant(id: string, data: TenantUpdate) {
  const res = await api.put<TenantInfo>(`/super-admin/tenants/${id}`, data);
  return res.data;
}
